/**
 * CommentStats 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CommentStats
 */
export interface CommentStats {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键，和主表的主键一致 */
  id?: string
  /** 点赞次数 */
  like_count?: number
  /** 子回复数量（基于parent_comment_id统计） */
  reply_count?: number
  /** 子评论用户数量 */
  children_user_count?: number
  /** 点踩次数 */
  dislike_count?: number
  /** 收藏次数 */
  collect_count?: number
  /** 被举报次数 */
  report_count?: number
  /** 最近点赞时间 */
  last_liked_at?: string
  /** 最近点赞用户ID */
  last_liked_user_id?: string
  /** 最近点踩时间 */
  last_disliked_at?: string
  /** 最近点踩用户ID */
  last_disliked_user_id?: string
  /** 最近收藏时间 */
  last_collected_at?: string
  /** 最近收藏用户ID */
  last_collected_user_id?: string
  /** 最近回复时间 */
  last_replied_at?: string
  /** 最近回复用户ID */
  last_replied_user_id?: string
  /** 最近举报时间 */
  last_reported_at?: string
  /** 最近举报用户ID */
  last_reported_user_id?: string
}

/**
 * CommentStats Schema
 */
export const CommentStatsSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键，和主表的主键一致',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    like_count: {
      description: '点赞次数',
      format: 'int',
      type: 'integer',
      label: '点赞次数',
    },
    reply_count: {
      description: '子回复数量（基于parent_comment_id统计）',
      format: 'int',
      type: 'integer',
      label: '子回复数量',
    },
    children_user_count: {
      description: '子评论用户数量',
      format: 'int',
      type: 'integer',
      label: '子评论用户数量',
    },
    dislike_count: {
      description: '点踩次数',
      format: 'int',
      type: 'integer',
      label: '点踩次数',
    },
    collect_count: {
      description: '收藏次数',
      format: 'int',
      type: 'integer',
      label: '收藏次数',
    },
    report_count: {
      description: '被举报次数',
      format: 'int',
      type: 'integer',
      label: '被举报次数',
    },
    last_liked_at: {
      description: '最近点赞时间',
      format: '*time.Time',
      type: 'string',
      label: '最近点赞时间',
    },
    last_liked_user_id: {
      description: '最近点赞用户ID',
      format: 'string',
      type: 'string',
      label: '最近点赞用户ID',
    },
    last_disliked_at: {
      description: '最近点踩时间',
      format: '*time.Time',
      type: 'string',
      label: '最近点踩时间',
    },
    last_disliked_user_id: {
      description: '最近点踩用户ID',
      format: 'string',
      type: 'string',
      label: '最近点踩用户ID',
    },
    last_collected_at: {
      description: '最近收藏时间',
      format: '*time.Time',
      type: 'string',
      label: '最近收藏时间',
    },
    last_collected_user_id: {
      description: '最近收藏用户ID',
      format: 'string',
      type: 'string',
      label: '最近收藏用户ID',
    },
    last_replied_at: {
      description: '最近回复时间',
      format: '*time.Time',
      type: 'string',
      label: '最近回复时间',
    },
    last_replied_user_id: {
      description: '最近回复用户ID',
      format: 'string',
      type: 'string',
      label: '最近回复用户ID',
    },
    last_reported_at: {
      description: '最近举报时间',
      format: '*time.Time',
      type: 'string',
      label: '最近举报时间',
    },
    last_reported_user_id: {
      description: '最近举报用户ID',
      format: 'string',
      type: 'string',
      label: '最近举报用户ID',
    },
  },
  type: 'object',
}
